import GoodsSliderMolibden from "../Сatalog/GoodsSlider/Molibden/GoodsSlider";
import GoodsSliderBor from "../Сatalog/GoodsSlider/Bor/GoodsSlider";
import GoodsSliderZink from "../Сatalog/GoodsSlider/Zink/GoodsSlider";
import GoodsSliderPhosphorus from "../Сatalog/GoodsSlider/Phosphorus/GoodsSlider";
import GoodsSliderUniversal from "../Сatalog/GoodsSlider/Universal/GoodsSlider";
import GoodsSliderLodine from "../Сatalog/GoodsSlider/Lodine/GoodsSlider";
import Button from "../../assets/Button/ButtonBuy/ButtonBuy"
import molibImg from "../../image/goods.image/agrobolik/br-molib/Бор+Моліб_40л.jpg"
import molibImg2 from "../../image/goods.image/agrobolik/br-molib/Бор+Моліб_20л.jpg"
import molibImg3 from "../../image/goods.image/agrobolik/br-molib/Бор+Моліб_1л.jpg"
import phosImg from "../../image/goods.image/agrobolik/Phosphorus/Фос_20л.jpg"
import phosImg2 from "../../image/goods.image/agrobolik/Phosphorus/Фос_1л.jpg"
import uniImg from "../../image/goods.image/agrobolik/Universal/Ун_40л.jpg"
import uniImg2 from "../../image/goods.image/agrobolik/Universal/Ун_20л.jpg"
import uniImg3 from "../../image/goods.image/agrobolik/Universal/Ун_1л.jpg"
import borImg from "../../image/goods.image/agrobolik/bor/Бор_40л.jpg"
import borImg2 from "../../image/goods.image/agrobolik/bor/Бор_20л-removebg-preview.png"
import borImg3 from "../../image/goods.image/agrobolik/bor/Бор_1л.jpg"
import zinkImg from "../../image/goods.image/agrobolik/Zink/Цинк_40л.jpg"
import zinkImg2 from "../../image/goods.image/agrobolik/Zink/Цинк_20л-removebg-preview.png"
import zinkImg3 from "../../image/goods.image/agrobolik/Zink/Цинк_1л.jpg"
import lodineImg from "../../image/goods.image/agrobolik/Lodine/Йод_40л.jpg"
import lodineImg2 from "../../image/goods.image/agrobolik/Lodine/Йод_20л.jpg"
import lodineImg3 from "../../image/goods.image/agrobolik/Lodine/Йод_1л.jpg"

// import { Link } from "react-router-dom";

export const items = [
  {
    title: 'Агроболік Бор + Молібден',
    skuFirst: "AGB-BOR-MO-20L",
    skuSecond: "AGB-BOR-MO-10L",
    skuThird: "AGB-BOR-MO-1L",
    skuFourth: "AGB-BOR-MO-0_5L",
    imgFirst: molibImg,
    imgSecond: molibImg2,
    imgThird: molibImg3,
    imgFourth: molibImg3,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '7 000 грн',
    priceSecond: '3 600 грн ',
    priceThird: '420 грн',
    priceFourth: '320 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-bormolibden-10l/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "molibden",
    imgUrl: <GoodsSliderMolibden />,
    isNew: false,
    id: "1"
  },
  {
    title: 'Агроболік Фосфор',
    skuFirst: "AGB-P-20L",
    skuSecond: "AGB-P-10L",
    skuThird: "AGB-P-1L",
    skuFourth: "AGB-P-0_5L",
    imgFirst: phosImg,
    imgSecond: phosImg,
    imgThird: phosImg2,
    imgFourth: phosImg2,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '5 200 грн',
    priceSecond: '2 700 грн',
    priceThird: '350 грн',
    priceFourth: '240 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-fosfor-20l/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "phosphor",
    imgUrl: <GoodsSliderPhosphorus />,
    isNew: false,
    id: "2"
  },
  {
    title: 'Агроболік Універсал',
    skuFirst: "AGB-UN-20L",
    skuSecond: "AGB-UN-10L",
    skuThird: "AGB-UN-1L",
    skuFourth: "AGB-UN-0_5L",
    imgFirst: uniImg,
    imgSecond: uniImg2,
    imgThird: uniImg3,
    imgFourth: uniImg3,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '3 400 грн',
    priceSecond: '1 800 грн',
    priceThird: '240 грн',
    priceFourth: '160 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-universalne-20l/538/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "universal",
    imgUrl: <GoodsSliderUniversal />,
    isNew: false,
    id: "3"
  },
  {
    title: 'Агроболік Бор',
    skuFirst: "AGB-BOR-20L",
    skuSecond: "AGB-BOR-10L",
    skuThird: "AGB-BOR-1L",
    skuFourth: "AGB-BOR-0_5L",
    imgFirst: borImg,
    imgSecond: borImg2,
    imgThird: borImg3,
    imgFourth: borImg3,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '3 400 грн',
    priceSecond: '1 800 грн',
    priceThird: '240 грн',
    priceFourth: '160 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-bor-10l/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "bor",
    imgUrl: <GoodsSliderBor />,
    isNew: false,
    id: "4"
  },
  {
    title: 'Агроболік Цинк',
    sku: "AGB-23145-1231",
    skuFirst: "AGB-ZN-20L",
    skuSecond: "AGB-ZN-10L",
    skuThird: "AGB-ZN-1L",
    skuFourth: "AGB-ZN-0_5L",
    imgFirst: zinkImg,
    imgSecond: zinkImg2,
    imgThird: zinkImg3,
    imgFourth: zinkImg3,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '3 400 грн',
    priceSecond: '1 800 грн',
    priceThird: '240 грн',
    priceFourth: '160 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-tsynk-20l/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "zinc",
    imgUrl: <GoodsSliderZink />,
    isNew: false,
    id: "5"
  },
  {
    title: 'Агроболік Йод',
    skuFirst: "AGB-Y-20L",
    skuSecond: "AGB-Y-10L",
    skuThird: "AGB-Y-1L",
    skuFourth: "AGB-Y-0_5L",
    imgFirst: lodineImg,
    imgSecond: lodineImg2,
    imgThird: lodineImg3,
    imgFourth: lodineImg3,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '7 000 грн',
    priceSecond: '3 600 грн',
    priceThird: '430 грн',
    priceFourth: '350 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-yod-20l/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "iodine",
    imgUrl: <GoodsSliderLodine />,
    isNew: false,
    id: "6"
  }
];

export const item = [
  {
    title: 'Агроболік Бор',
    skuFirst: "AGB-BOR-20L",
    skuSecond: "AGB-BOR-10L",
    skuThird: "AGB-BOR-1L",
    skuFourth: "AGB-BOR-0_5L",
    imgFirst: borImg,
    imgSecond: borImg2,
    imgThird: borImg3,
    imgFourth: borImg3,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '3 400 грн',
    priceSecond: '1 800 грн',
    priceThird: '240 грн',
    priceFourth: '160 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-bor-10l/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "bor",
    imgUrl: <GoodsSliderBor />,
    isNew: false,
    id: "1"
  },
  {
    title: 'Агроболік Фосфор',
    skuFirst: "AGB-P-20L",
    skuSecond: "AGB-P-10L",
    skuThird: "AGB-P-1L",
    skuFourth: "AGB-P-0_5L",
    imgFirst: phosImg,
    imgSecond: phosImg,
    imgThird: phosImg2,
    imgFourth: phosImg2,
    unitFirst: "20л",
    unitSecond: "10л",
    unitThird: "1л",
    unitFourth: "0,5л",
    priceFirst: '5 200 грн',
    priceSecond: '2 700 грн',
    priceThird: '350 грн',
    priceFourth: '240 грн',
    InStock: true,
    link: <a className="navigation__link--hover" href="https://sun-ukr.vn.ua/dobryvo-ahrobolik-fosfor-20l/" target="_blank" rel="noopener noreferrer"><Button /></a>,
    inside: "phosphor",
    imgUrl: <GoodsSliderPhosphorus />,
    isNew: true,
    id: "2"
  }
];
